import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";
// import alerts from "./modules/alerts-module";
import profile from "./modules/profile-module";
import users from "./modules/users-module";
import roles from "./modules/roles-module";
import tags from "./modules/tags-module";
import items from "./modules/items-module";
import reset from "./modules/reset";
//import tipos from "./modules/tipos-maquina-module";
import empresas from "./modules/empresas-module";
import categories from "./modules/categories-module";
import divisiones from "./modules/divisiones-module";
import tipos from "./modules/tipos-module";
import subtipos from "./modules/subtipos-module";
import activos from "./modules/activos-module";
import fabricantes from "./modules/fabricantes-module";
import modelos from "./modules/modelos-module";
import revisiones from "./modules/revisiones-module";
import tareas from "./modules/tareas-module";
import tiposTarea from "./modules/tipos-tarea-module";
import estadosTarea from "./modules/estados-tarea-module";
import notificaciones from "./modules/notificaciones-module";
import incidencias from "./modules/incidencias-module";
import invitacions from "./modules/invitaciones-module";
import tiposNotificacion from "./modules/tipos-notificacion-module";
import estadosNotificacion from "./modules/estados-notificacion-module";
import albaranes from "./modules/albaranes";
import albaranActivoMaterials from "./modules/albaran-activo-materials";
import vistaOperativa from "./modules/vistaOperativa";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    // alerts,
    profile,
    users,
    roles,
    tags,
    divisiones,
    tipos,
    subtipos,
    empresas,
    categories,
    activos,
    fabricantes,
    modelos,
    items,
    reset,
    revisiones,
    tareas,
    tiposTarea,
    estadosTarea,
    notificaciones,
    incidencias,
    invitacions,
    tiposNotificacion,
    estadosNotificacion,
    albaranes,
    albaranActivoMaterials,
    vistaOperativa,
  },
});
